import { NgModule } from '@angular/core';
import { MobxAutorunDirective } from './directives/mobx-autorun.directive';
import { MobxAutorunSyncDirective } from './directives/mobx-autorun-sync.directive';
import { MobxReactionDirective } from './directives/mobx-reaction.directive';
import { action as mobxAction } from 'mobx';
import { computed as mobxComputed } from 'mobx';
import { observable as mobxObservable } from 'mobx';
import * as ɵngcc0 from '@angular/core';
export { MobxAutorunDirective, MobxAutorunSyncDirective, MobxReactionDirective };
var DIRECTIVES = [
    MobxAutorunDirective,
    MobxAutorunSyncDirective,
    MobxReactionDirective
];
var MobxAngularModule = /** @class */ (function () {
    function MobxAngularModule() {
    }
    /** @nocollapse */
    MobxAngularModule.ctorParameters = function () { return []; };
MobxAngularModule.ɵfac = function MobxAngularModule_Factory(t) { return new (t || MobxAngularModule)(); };
MobxAngularModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MobxAngularModule });
MobxAngularModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MobxAngularModule, [{
        type: NgModule,
        args: [{
                declarations: DIRECTIVES,
                exports: DIRECTIVES,
                imports: [],
                providers: []
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MobxAngularModule, { declarations: [MobxAutorunDirective,
        MobxAutorunSyncDirective,
        MobxReactionDirective], exports: [MobxAutorunDirective,
        MobxAutorunSyncDirective,
        MobxReactionDirective] }); })();
    return MobxAngularModule;
}());
export { MobxAngularModule };
export function actionInternal() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return mobxAction.apply(void 0, args);
}
export var action = Object.assign(actionInternal, mobxAction);
function computedInternal() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return mobxComputed.apply(void 0, args);
}
export var computed = Object.assign(computedInternal, mobxComputed);
function observableInternal() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return mobxObservable.apply(void 0, args);
}
export var observable = Object.assign(observableInternal, mobxObservable);

